import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, provideAppInitializer, inject, importProvidersFrom, LOCALE_ID, isDevMode} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';
import { routes } from '@routes/app.routes';
import { Global } from '@services/global.service';
import { apiResponseInterceptor, apiRequestInterceptor } from '@interceptors/api.interceptor';
import { offerInterceptor } from '@interceptors/offer.interceptor';
import { provideServiceWorker } from '@angular/service-worker';


export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
    provideHttpClient(withInterceptors([apiResponseInterceptor, apiRequestInterceptor, offerInterceptor])),
    provideAppInitializer(() => inject(Global).init()),

    //recaptcha
    importProvidersFrom(RecaptchaV3Module),
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LffTwcsAAAAAD7I6jkU0BTpvsGyu2Qbtasy7xPh' },
    provideServiceWorker('ngsw-worker.js', {
      enabled: /*true,*/ !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
